app.controller("subscriptionOrderCompleteCtrl", [
  "$scope",
  "$location",
  "StripePaymentFactory",
  function ($scope, $location, StripePaymentFactory) {
    $scope.orderStatus = null;
    $scope.orderStatusMessage = null;
    $scope.gettingOrderStatus = false;
    let nextActionUrl = "/home";

    function navigate() {
      $location.path(nextActionUrl).search({});
    }
    $scope.navigate = navigate;

    function getPaymentIntentStatus(paymentIntent) {
      $scope.gettingOrderStatus = true;
      StripePaymentFactory.stripeConnectToken()
        .then(function (stripeToken) {
          const stripe = Stripe(stripeToken);
          stripe
            .retrievePaymentIntent(paymentIntent)
            .then(function (result) {
              if (result.paymentIntent) {
                switch (result.paymentIntent.status) {
                  case "succeeded":
                    $scope.orderStatus = "succeeded";
                    $scope.orderStatusMessage = "Success! Payment received.";
                    break;

                  case "processing":
                    $scope.orderStatus = "processing";
                    $scope.orderStatusMessage =
                      "Payment processing. We'll update you when payment is received.";
                    break;

                  case "requires_payment_method":
                    $scope.orderStatus = "requires_payment_method";
                    $scope.orderStatusMessage =
                      "Payment failed. Please try another payment method.";
                    nextActionUrl = "/subscribe";
                    // Redirect your user back to your payment page to attempt collecting
                    // payment again
                    break;

                  default:
                    $scope.orderStatus = "error";
                    $scope.orderStatusMessage = "Something went wrong.";
                    break;
                }
              }
              if (result.error) {
                $scope.orderStatus = "error";
                $scope.orderStatusMessage =
                  "There was an error retrieving the payment order details";
              }
            })
            .catch(function (err) {
              $scope.orderStatus = "error";
              $scope.orderStatusMessage =
                "There was an error retrieving the payment order details";
            });
        })
        .catch(function (err) {
          $scope.orderStatus = "error";
          $scope.orderStatusMessage = "Something went wrong.";
        });
    }
    const params = $location.search();

    if (params.payment_intent && params.payment_intent_client_secret) {
      getPaymentIntentStatus(params.payment_intent_client_secret);
    }
  },
]);
